import AreaChartWrapper from './app-area.chart';
export default AreaChartWrapper;